import { render } from "./RecomCCTV.vue?vue&type=template&id=92534c54"
import script from "./RecomCCTV.vue?vue&type=script&lang=js"
export * from "./RecomCCTV.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__